import styled, { keyframes } from 'styled-components';

const ldsRipple = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const LoaderBody = styled.div`
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  
  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 51px;
    height: 51px;
    margin: 6px;
    border-width: 3px;
    border-style: solid;
    border-radius: 50%;
    animation: ${ldsRipple} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${({ theme }) => theme.blue} transparent transparent transparent;
    
    &:nth-child(1) {
      animation-delay: -0.45s;
    }
    &:nth-child(2) {
      animation-delay: -0.3s;
    }
    &:nth-child(3) {
      animation-delay: -0.15s;
    }
  }
`;
